/*
 * <product-auto-siblings> (snippets/product-auto-siblings.liquid): cores "irmãs" do
 * produto, achadas pelo título. Carregado em todas as páginas por layout/theme.liquid
 * para funcionar também no compre rápido, que entra na página via fetch (script
 * inline não roda nesse caso, custom element sim).
 *
 * Título esperado: "Nome Base - Modelo Cor". Busca os produtos que começam com
 * "Nome Base - Modelo" e adiciona uma bolinha de cor para cada irmão disponível,
 * dentro do seletor de cor do próprio produto (página do produto ou compre rápido).
 */
(function () {
  if (customElements.get('product-auto-siblings')) return;

  // Normaliza espaços (non-breaking space, etc.) e dashes (en-dash, em-dash)
  function normalizeStr(t) {
    return t
      .normalize('NFC')
      .replace(/[   ​]/g, ' ') // non-breaking spaces → space
      .replace(/\s*[–—‐‑−]\s*/g, ' - ') // all dash types → " - "
      .replace(/\s+/g, ' ') // multiple spaces → single
      .trim();
  }

  function removeAccents(t) {
    return t.normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // Cores do swatches.json + cores customizadas: carrega uma vez por página
  let swatchColors = null;

  function loadSwatchColors(swatchesUrl) {
    if (swatchColors) return swatchColors;

    swatchColors = fetch(swatchesUrl)
      .then((r) => r.json())
      .then((data) => {
        const map = {};
        (data.colors || []).forEach((entry) => {
          const key = Object.keys(entry)[0];
          map[key.toLowerCase()] = entry[key];
        });
        try {
          const customEl = document.getElementById('custom-swatches-data');
          if (customEl) {
            JSON.parse(customEl.textContent).forEach((entry) => {
              const key = Object.keys(entry)[0];
              map[key.toLowerCase()] = entry[key];
            });
          }
        } catch (e) {}
        return map;
      })
      .catch(() => ({}));

    return swatchColors;
  }

  function suggest(term) {
    const params = `q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=25&resources[options][fields]=title`;
    return fetch(`/search/suggest.json?${params}`)
      .then((r) => r.json())
      .then((data) => data.resources.results.products || []);
  }

  class ProductAutoSiblings extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.currentHandle = this.dataset.handle;
      this.swatchStyle = this.dataset.swatchStyle;
      this.swatchTranslation = this.dataset.swatchTranslation || '';

      // Só mexe no produto deste bloco: na página do produto pode haver um compre rápido aberto e vice-versa
      // (data-quick-view-item: no "Shop the look" o compre rápido tem vários produtos)
      this.scope = this.closest('[data-quick-view-item]') || this.closest('[data-section-id]') || document;

      const normalizedTitle = normalizeStr(this.dataset.title || '');
      const dashIndex = normalizedTitle.lastIndexOf(' - ');
      if (dashIndex === -1) return;

      const titleBase = normalizedTitle.substring(0, dashIndex);
      const lastPartWords = normalizedTitle
        .substring(dashIndex + 3)
        .split(' ')
        .filter((w) => w.length > 0);
      if (lastPartWords.length < 2) return;

      this.colorName = lastPartWords.slice(1).join(' ');
      this.baseName = `${titleBase} - ${lastPartWords[0]}`;

      Promise.all([this.searchSiblings(), loadSwatchColors(this.dataset.swatchesUrl)]).then(([siblings, colorMap]) => {
        if (siblings.length === 0 || !this.isConnected) return;
        this.renderSiblings(siblings, colorMap);
      });
    }

    filterSiblings(products) {
      const baseNorm = removeAccents(this.baseName).toLowerCase();
      return products.filter((p) => {
        const pTitle = normalizeStr(p.title);
        return removeAccents(pTitle).toLowerCase().indexOf(baseNorm) === 0 && pTitle.length > this.baseName.length && p.handle !== this.currentHandle;
      });
    }

    searchSiblings() {
      // Busca 1: com o termo original; busca 2: sem acentos
      const searchTerm = this.baseName.replace(/\s-\s/g, ' ');
      return suggest(searchTerm)
        .then((products) => {
          const filtered = this.filterSiblings(products);
          if (filtered.length > 0) return filtered;
          return suggest(removeAccents(searchTerm)).then((products2) => this.filterSiblings(products2));
        })
        .catch(() => []);
    }

    fetchProductData(handle) {
      return fetch(`/products/${handle}.js`)
        .then((r) => r.json())
        .then((data) => {
          let color = '';
          const swatchOptions = this.swatchTranslation
            .toLowerCase()
            .split(',')
            .map((s) => s.trim());

          if (data.options && data.variants && data.variants.length > 0) {
            for (let i = 0; i < data.options.length; i++) {
              const optName = (data.options[i].name || data.options[i]).toLowerCase().trim();
              if (swatchOptions.indexOf(optName) !== -1) {
                color = data.variants[0][`option${i + 1}`] || '';
                break;
              }
            }
          }

          return { available: data.available, color };
        })
        .catch(() => ({ available: true, color: '' }));
    }

    extractColor(title) {
      const normalized = normalizeStr(title);
      if (removeAccents(normalized).toLowerCase().indexOf(removeAccents(this.baseName).toLowerCase()) === 0) {
        return normalized.substring(this.baseName.length).trim();
      }
      return '';
    }

    getOrCreateSwatchContainer() {
      const existing = this.scope.querySelector('.product__selector--color [data-variant-buttons]');
      if (existing) return existing;

      // Container próprio quando o produto não tem opção de cor
      const swatchStyle = this.swatchStyle;
      const colorName = this.colorName;
      const wrapper = document.createElement('div');
      wrapper.className = 'product__block product__selector product__selector--color auto-siblings-standalone';
      wrapper.setAttribute('data-auto-siblings', '');

      const fieldset = document.createElement('fieldset');
      fieldset.className = `radio__fieldset radio__fieldset--${swatchStyle}`;

      const legend = document.createElement('legend');
      legend.className = 'radio__legend';
      legend.innerHTML = '<span class="radio__legend__label label-typography">Cores Disponíveis:</span>';

      const buttonsDiv = document.createElement('div');
      buttonsDiv.className = 'radio__buttons';
      buttonsDiv.setAttribute('data-variant-buttons', '');

      // Swatch do produto atual
      const currentSpan = document.createElement('span');
      currentSpan.className = `swatch__button swatch__button--${swatchStyle}`;

      const currentLabel = document.createElement('span');
      currentLabel.className = 'swatch__label swatch__label--sibling';
      currentLabel.setAttribute('data-swatch', colorName);
      currentLabel.setAttribute('data-tooltip', colorName);
      currentLabel.setAttribute('aria-current', 'true');
      currentLabel.style.setProperty('--swatch', `var(--${colorName.toLowerCase().replace(/\s+/g, '-')})`);
      currentLabel.style.border = '2px solid #000';

      const currentSr = document.createElement('span');
      currentSr.className = 'visually-hidden';
      currentSr.textContent = colorName;
      currentLabel.appendChild(currentSr);
      currentSpan.appendChild(currentLabel);
      buttonsDiv.appendChild(currentSpan);

      fieldset.appendChild(legend);
      fieldset.appendChild(buttonsDiv);
      wrapper.appendChild(fieldset);

      // Inserir após o título ou antes dos selectors
      const insertTarget =
        this.scope.querySelector('.product__title__wrapper') ||
        this.scope.querySelector('.product__title') ||
        this.scope.querySelector('.popup-quick-view__title') ||
        this.scope.querySelector('.product__selectors');
      if (insertTarget) {
        insertTarget.parentNode.insertBefore(wrapper, insertTarget.nextSibling);
      } else {
        const formWrapper = this.scope.querySelector('.form__wrapper');
        if (!formWrapper) return null;
        formWrapper.insertBefore(wrapper, formWrapper.firstChild);
      }

      return buttonsDiv;
    }

    renderSiblings(siblings, colorMap) {
      const swatchContainer = this.getOrCreateSwatchContainer();
      if (!swatchContainer) return;

      // Atualizar swatch atual com cor do colorMap
      const currentHex = colorMap[this.colorName.toLowerCase()] || null;
      const currentSwatch = swatchContainer.querySelector('[aria-current="true"]');
      if (currentHex && currentSwatch) {
        currentSwatch.style.setProperty('--swatch', currentHex);
      }

      const productDataChecks = siblings.map((sib) =>
        this.fetchProductData(sib.handle).then((data) => {
          sib.available = data.available;
          sib.optionColor = data.color;
          return sib;
        })
      );

      Promise.all(productDataChecks).then((siblingsWithStock) => {
        siblingsWithStock.sort((a, b) => {
          if (a.available && !b.available) return -1;
          if (!a.available && b.available) return 1;
          return a.title.localeCompare(b.title);
        });

        siblingsWithStock.forEach((sib) => {
          if (!sib.available) return;

          const color = sib.optionColor || this.extractColor(sib.title.trim());
          if (!color) return;

          const colorLower = color.toLowerCase();
          const hexColor = colorMap[colorLower] || null;

          const span = document.createElement('span');
          span.className = `swatch__button swatch__button--${this.swatchStyle}`;

          const link = document.createElement('a');
          link.href = sib.url;
          link.className = 'swatch__label swatch__label--sibling';
          link.setAttribute('data-swatch', color);
          link.setAttribute('data-tooltip', color);
          link.style.setProperty('--swatch', hexColor || `var(--${colorLower.replace(/\s+/g, '-')})`);

          const srSpan = document.createElement('span');
          srSpan.className = 'visually-hidden';
          srSpan.textContent = color;
          link.appendChild(srSpan);

          span.appendChild(link);
          swatchContainer.appendChild(span);
        });
      });
    }
  }

  customElements.define('product-auto-siblings', ProductAutoSiblings);
})();
